import {SharedInitGuard} from '@shared/guards/shared-init.guard';
import { linkHomeRedirect } from '@link/guards/link-home-redirect';
import {mapToCanActivate, Route} from '@angular/router';
import {LinkLoginGuard} from '@link/guards/link-login.guard';
import {LinkHomeGuard} from '@link/guards/link-home.guard';
import {LinkKnowledgeGuard} from '@link/guards/link-knowledge.guard';
import {LinkPropertiesGuard} from '@link/guards/link-properties.guard';
import {linkKnowledgeResolver} from '@link/pages/knowledge/resolvers/link-knowledge.resolver';
import {linkArticleResolver} from '@link/pages/knowledge/resolvers/link-article.resolver';
import {getSharedIssueRoutes} from "@core/helpers/methods/core-issue-routes.helper";
import {LinkIssueGuard} from "@link/guards/link-issue.guard";

export default [
  {
    path: 'home',
    pathMatch: 'full',
    redirectTo: linkHomeRedirect,
  },
  {
    path: 'not-allowed',
    loadComponent: () => import('@shared/components/login/pages/not-allowed/shared-not-allowed.page').then(m => m.SharedNotAllowedPage),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'link',
  },
  {
    path: 'link',
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        loadComponent: () => import('@link/pages/login/link-login.page').then(m => m.LinkLoginPage),
      },
      {
        path: 'init',
        canActivate: [SharedInitGuard],
        loadComponent: () => import('@shared/components/login/pages/init/shared-init.page').then(m => m.SharedInitPage),
      },
      {
        path: 'error',
        loadComponent: () => import('@shared/components/login/pages/not-allowed/shared-not-allowed.page').then(m => m.SharedNotAllowedPage),
      },
      {
        path: ':id',
        loadComponent: () => import('./pages/link-main.page').then(m => m.LinkMainPage),
        canActivate: mapToCanActivate([LinkLoginGuard]),
        children: [
          {
            path: 'home',
            loadComponent: () => import('./pages/home/link-home.page').then(m => m.LinkHomePage),
            canActivate: mapToCanActivate([LinkHomeGuard]),
          },
          {
            path: 'knowledge',
            loadComponent: () => import('./pages/knowledge/link-knowledge.page').then(m => m.LinkKnowledgePage),
            canActivate: mapToCanActivate([LinkKnowledgeGuard]),
            resolve: { knowledge: linkKnowledgeResolver },
            data: { isBackButtonEnable: true },
          },
          {
            path: 'knowledge/:id',
            loadComponent: () => import('@link/pages/knowledge/pages/knowledge-article/link-knowledge-article.page').then(m => m.LinkKnowledgeArticlePage),
            resolve: { article: linkArticleResolver },
          },
          {
            path: 'properties',
            loadComponent: () => import('./pages/properties/link-properties.page').then(m => m.LinkPropertiesPage),
            canActivate: mapToCanActivate([LinkPropertiesGuard]),
          },
          ...getSharedIssueRoutes(),
          {
            path: 'issues',
            loadComponent: () => import('@link/pages/issues/link-issue.page').then(m => m.LinkIssuePage),
            canActivate: mapToCanActivate([LinkIssueGuard]),
          },
        ]
      },
    ],
  },
] as Route[];
